
import uiAlert from '@/component/uiAlert/uiAlert'
import uiConfirm from '@/component/uiConfirm/uiConfirm'
import uiBottom from '@/component/uiBottom'
import uiUploadPhoto from '@/component/uiUploadPhoto'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
uiAlert,
uiConfirm,
uiBottom,
uiUploadPhoto,
XButton
},
data () {
return {
showDialog1: false,
showDialog2: false,
uploadImg: '',
content: {
title: this.$t('demo.rule.title'),
list: this.$t('demo.rule.content')
}
}
},
methods: {
enter (url) {
this.$router.push({ path: url })
},
jump () {
console.log('jump')
},
toast () {
this.$toast({ msg: '自定义toast', time: 500 })
},
confirm () {
this.$confirm({
title: '知道了',
content: 'Vue.use 会自动阻止多次注册相同插件，届时只会注册一次该插件。',
buttonText: [
{
id: 'ok',
text: '确定'
},
{
id: 'cancel',
text: '取消'
}
]
}).then(() => {
console.log('yes')
}).catch(() => {
console.log('no')
})
},
alert () {
this.$alert({
content: {
title: this.$t('demo.rule.title'),
list: this.$t('demo.rule.content')
}
})
},
sendImg (img, file) {
this.uploadImg = img







},
deleteImg () {
this.uploadImg = ''
}
},
created () {

this.$http.get(`/v1/api/eas/activity/solarTermsHiking/canPunch`).then(res => {

})

this.$http.get(`/v1/api/eas/user/integral_details`, {
page: 1,
pageSize: 10,
userId: '111'
}).then(res => {

})

let param = {
header: {
systemtime: '20171013184910288',
version: '1.0'
},
body: {}
}
this.$http.post('/v1/api/ad/couponArea/getStoreTypeList', param).then(res => {
console.log(res)
})
},
mounted () {
}
}



// WEBPACK FOOTER //
// ./src/page/demo/demo.vue